import { createAction } from '@reduxjs/toolkit';
import type { BizCategoryType } from 'reactApp/modules/bizCategories/bizCategories.types';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';

export const initBizCategories = createAction<EStorageType>('bizCategories/initBizCategories');
export const setCurrentCategory = createAction<BizCategoryType | undefined>('bizCategories/setCurrentCategory');
